import axios from "axios";

// ZATCA Phase 2 (API ZatcaController, DB script section 32): branch setup and
// certificate import, the QR for prints, the ZATCA Report and sending again.
// Errors come back as { Message }: 400 for a broken rule, 409 for a state clash.
const base_path = window.APP_CONFIG?.BASE_URL;
const Z = `${base_path}/Api/Zatca`;

export const zatcaError = (error, fallback) =>
  error?.response?.data?.Message || error?.response?.data?.message || fallback;

/** Every branch with its ZATCA setup (no keys or secrets). */
export const getZatcaSetups = async () => {
  const response = await axios.get(`${Z}/GetSetups`);
  return response.data || [];
};

/** { branchID, isEnabled, environmentType, startDate, sellerName, vatNumber, crNumber, streetName,
 *    buildingNumber, citySubdivision, cityName, postalZone, countryCode, updatedUser } */
export const saveZatcaSetup = async (setup) => {
  const response = await axios.post(`${Z}/SaveSetup`, setup);
  return response.data;
};

/** The branch's CertificateInfo.json as text. Resolves to { icv, pih, chainFromFile, environmentType, certificateSubject, certificateValidTo }. */
export const importZatcaCertificate = async ({ branchID, fileName, content, updatedUser }) => {
  const response = await axios.post(`${Z}/ImportCertificate`, { branchID, fileName, content, updatedUser });
  return response.data;
};

/**
 * What a print needs: { enabled, qrCode, status, documentType, message }.
 * By the sale's guid, or right after saving (guid unknown) by branch + number + type ("SI" / "SR").
 */
export const getZatcaPrintInfo = async ({ salesGuid, branchID, entryNumber, transType }) => {
  const params = new URLSearchParams();
  if (salesGuid) params.set("salesGuid", salesGuid);
  if (branchID) params.set("globalBranchID", branchID);
  if (entryNumber) params.set("entryNumber", entryNumber);
  if (transType) params.set("transType", transType);
  const response = await axios.get(`${Z}/GetPrintInfo?${params.toString()}`);
  return response.data;
};

/** { rows: [...], yearTotal, yearDone, yearPending, yearRejected }; status: ALL / PENDING / UNSIGNED / REPORTED / CLEARED / REJECTED / SEND_FAILED */
export const getZatcaReport = async (branchID, fromDate, toDate, status) => {
  const response = await axios.get(
    `${Z}/GetReport?globalBranchID=${branchID}&fromDate=${fromDate}&toDate=${toDate}&status=${status || "ALL"}`
  );
  return response.data;
};

/** Sign and send the given invoices, or (no guids) everything of the branch that is due. */
export const resubmitZatca = async (branchID, salesGuIDs = []) => {
  const response = await axios.post(`${Z}/Resubmit`, { branchID, salesGuIDs });
  return response.data;
};

/** Downloads the signed (or cleared) XML of one invoice, saved as `fileName`. */
export const downloadZatcaXml = async (salesGuid, fileName) => {
  const response = await axios.get(`${Z}/DownloadXml?salesGuid=${salesGuid}`, { responseType: "blob" });
  const disposition = response.headers?.["content-disposition"] || "";
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const url = window.URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName || (match ? match[1] : `${salesGuid}.xml`);
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
